import { RiExpandUpDownLine } from "react-icons/ri";
import { countries } from "utils/data";

const FilterSelect = ({
	name,
	value,
	onChange,
	label,
	options,
	optionValueKey = "name",
	optionLabelKey = "name",
	className = "",
}) => (
	<div className={`relative flex-1 min-w-[140px] max-w-[200px] ${className}`}>
		<select
			name={name}
			value={value || ""}
			onChange={onChange}
			className="w-full h-10 rounded-lg pl-3 pr-8 bg-white border border-gray-200 text-gray-700 text-sm hover:border-akgreen focus:border-akgreen focus:ring-1 focus:ring-akgreen transition-colors duration-200 appearance-none"
		>
			<option value="">{value ? "Clear filter [x]" : label}</option>
			{options?.map((option, index) => (
				<option
					key={index}
					value={typeof option === "object" ? option[optionValueKey]?.toString() : option}
				>
					{typeof option === "object" ? option[optionLabelKey] : option}
				</option>
			))}
		</select>
		<div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
			<RiExpandUpDownLine className="text-gray-400" size={16} />
		</div>
	</div>
);

const HorizontalBookFilter = ({ filters, publishers, genres, categories }) => {
	const pricingOptions = [
		{ id: "has_purchase", name: "sellable", label: "Purchase only" },
		{ id: "has_subscription", name: "subscription", label: "Subscription only" },
		{ id: "all", name: "all", label: "Both purchase & subscription" },
		{ id: "free", name: "free", label: "Free books" },
	];

	const formatOptions = [
		{ id: "digital", name: "digital", label: "Digital" },
		{ id: "physical", name: "physical", label: "Physical" },
		{ id: "both", name: "both", label: "Both" },
	];

	return (
		<div className="flex flex-wrap items-center gap-2">
			<FilterSelect
				name="publisherIs"
				value={filters?.publisherIs}
				onChange={(e) => filters.changePublisherIs(e.target.value)}
				label="Publisher"
				options={publishers}
				optionValueKey="id"
			/>
			<FilterSelect
				name="categoryIs"
				value={filters?.categoryIs}
				onChange={(e) => filters.changeCategoryIs(e.target.value)}
				label="Category"
				options={categories}
			/>
			<FilterSelect
				name="format"
				value={filters?.format}
				onChange={(e) => filters.changeFormat?.(e.target.value)}
				label="Format"
				options={formatOptions}
				optionLabelKey="label"
			/>
			<FilterSelect
				name="pricingModelIs"
				value={filters?.pricingModelIs}
				onChange={(e) => filters.changePricingModelIs(e.target.value)}
				label="Pricing model"
				options={pricingOptions}
				optionLabelKey="label"
			/>
			<FilterSelect
				name="countryIs"
				value={filters?.countryIs}
				onChange={(e) => filters.changeCountryIs(e.target.value)}
				label="Country"
				options={countries}
			/>
		</div>
	);
};

export default HorizontalBookFilter;
